module.exports = __webpack_public_path__ + "img/app-building.1c5186ca.jpg";